<script setup lang="ts">
import KUIUnifiedBadgeProgressIndicator from './KUIUnifiedBadgeProgressIndicator.vue';

export interface ProgressItem {
  id: string;
  completed: boolean;

}

interface Props {
  progress: ProgressItem[];
  iconPath: string;
  partnerBgColor: string;
}

const props = defineProps<Props>();

const completedProgress = computed(() => props.progress.filter(p => p.completed));
const incompletedProgress = computed(() => props.progress.filter(p => !p.completed));
</script>

<template>
  <div class="flex items-center justify-center gap-1 rounded-[32px] bg-black/15 px-4 py-1 shadow-[inset_1px_1px_0_0_rgba(255,255,255,0.55)] backdrop-blur-[2px]">
    <!-- completed icons -->
    <KUIUnifiedBadgeProgressIndicator
      v-for="item in completedProgress"
      :key="item.id"
      is-completed
      :icon-path="iconPath"
      :partner-bg-color="partnerBgColor"
    />

    <!-- incomplete icons -->
    <KUIUnifiedBadgeProgressIndicator
      v-for="item in incompletedProgress"
      :key="item.id"
      :icon-path="iconPath"
      :partner-bg-color="partnerBgColor"
    />
  </div>
</template>
